import * as React from 'react';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ImageLoaderComponent } from '../../../../toolkit/imageloader/imageloadercomponent';
import { ImageLoaderCSSStyle } from '../../../../toolkit/imageloader/imageloadercss';
import { PlayerComponent } from '../../../../toolkit/player/playercomponent';
import { PlayerComponentCSSStyle } from '../../../../toolkit/player/playercss';
import { UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { BannerCardComponentProps, BannerCardComponentState, BannerCardComponentHandler } from './bannercardcomponent';
import { BannerCardCSSStyle } from './bannercardcss';
import { BannerCardImageLoaderCSSStyleImpl } from './bannercardimageloader';
import { BannerCardMobileImageLoaderCSSStyleImpl } from './bannercardmobileimageloader ';
import { BannerCardPlayerCSSStyleImpl } from './bannercardplayercss';
import './banner-card.css';
import { BannerCardMobilePlayerCSSStyleImpl } from './bannercardmobileplayercss';

export class BannerCardViewImpl extends UIComponentViewImpl<UIDataModel> 
{  
    private imageLoaderCSSStyle: ImageLoaderCSSStyle;
    private imageMobileLoaderCSSStyle: ImageLoaderCSSStyle;
    private playerComponent: PlayerComponent | null;
    private initialStateOfTonePlaying: boolean;
    private playerCSSStyle: PlayerComponentCSSStyle;
    private mobilePlayerCSSStyle:PlayerComponentCSSStyle;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
        this.imageLoaderCSSStyle = new BannerCardImageLoaderCSSStyleImpl(context);
        this.imageMobileLoaderCSSStyle = new BannerCardMobileImageLoaderCSSStyleImpl(context);
        this.playerCSSStyle = new BannerCardPlayerCSSStyleImpl(context);
        this.mobilePlayerCSSStyle = new BannerCardMobilePlayerCSSStyleImpl(context);
    }

    bindHandlers()
    {
       this.onPlayClicked = this.onPlayClicked.bind(this);
       this.onPlayComplete = this.onPlayComplete.bind(this);
       this.onPlayStop = this.onPlayStop.bind(this);
       this.onStopClicked = this.onStopClicked.bind(this);
       this.bannerClick = this.bannerClick.bind(this);
    }

    draw(props: BannerCardComponentProps, state: BannerCardComponentState, cssStyle: BannerCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        return (
            <>
            <div id="banner-card-web" key={props.position} className="swiper-slide">
                {
                    this.getWebView(props, state, cssStyle)
                }
            </div>
             <div id="banner-card-mobile" key={props.position} className="swiper-slide">
            {
                this.getMobileView(props, state, cssStyle)
            }
            </div>
        </>
           
        );
    }
      
    getMobileView(props: BannerCardComponentProps, state: BannerCardComponentState, cssStyle: BannerCardCSSStyle)
    {
        return (
            <div style={cssStyle.getMobileBannerImageWrapperCSSStyle()}>
                   <div style={cssStyle.getBannerImageCSSStyle()} onClick={this.bannerClick}>
                     <ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.bannerDto.getImgPath()} imageLoaderCSSStyle={this.imageMobileLoaderCSSStyle} context={props.context}/>
                     <PlayerComponent playIconName={"play.svg"} pauseIconName={"pause.svg"} playerCSSStyle={this.mobilePlayerCSSStyle} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/>

                     {/* <PlayerWithProgressComponent  radialProgressBarCSSStyle={new BannerProgressBarCSSStyleImpl(props.context)} id={props.bannerDto.getId().toString()}  playIconName={"play.svg"} pauseIconName={"pause.svg"} playerCSSStyle={this.playerCSSStyle} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/> */}
                   </div>
                </div>
        );
    }

    getWebView(props: BannerCardComponentProps, state: BannerCardComponentState, cssStyle: BannerCardCSSStyle)
    {
        return (
            <div id="banner-web-wrapper" style={cssStyle.getWrapperCSSStyle()}>
                   <div style={cssStyle.getBannerImageCSSStyle()} onClick={this.bannerClick}>
                     <ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.bannerDto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/>
                     <PlayerComponent playIconName={"play.svg"} pauseIconName={"pause.svg"} playerCSSStyle={this.playerCSSStyle} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/>

                     {/* <PlayerWithProgressComponent  radialProgressBarCSSStyle={new BannerProgressBarCSSStyleImpl(props.context)} id={props.bannerDto.getId().toString()}  playIconName={"play.svg"} pauseIconName={"pause.svg"} playerCSSStyle={this.playerCSSStyle} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/> */}
                   </div>
                </div>
        );
    }
   
     
    onPlayComplete(): void 
    {
        console.log("---onPlay complete+++++++++++++++++++++++++++++++++++++++++++++++" + 
        this.initialStateOfTonePlaying);

        if(this.initialStateOfTonePlaying === true)
        {
            console.log("----auto start");
            (this.getUIProps() as BannerCardComponentProps).startAutoPlay();
        }
        this.initialStateOfTonePlaying = false;
        this.playerComponent !== null && this.playerComponent.onPlayComplete();
    }
   
    onPlayStop(): void 
    {
        console.log("---onStop complete");
        this.initialStateOfTonePlaying = false;
        this.playerComponent !== null && this.playerComponent.onPlayStop();
        // (this.getUIProps() as BannerCardComponentProps).startAutoPlay();
    }

    bannerClick()
    {
        (this.getUIComponentHandler() as BannerCardComponentHandler).onBannerClick();
    }    

     onPlayClicked(): void
    {
        console.log("---onPlayClicked");
        (this.getUIProps() as BannerCardComponentProps).stopAutoPlay();
        (this.getUIComponentHandler() as BannerCardComponentHandler).getBannerList();
    }

    startPlay(toneDto:ToneDto):void
    {
        this.initialStateOfTonePlaying = true;
        this.getContext().getPlayerManager().startPlay(toneDto.getToneUrl(), this);
       
    }

    onStopClicked(): void
    {
        this.initialStateOfTonePlaying = false;

        this.getContext().getPlayerManager().stopPlay();
        (this.getUIProps() as BannerCardComponentProps).startAutoPlay();
    }
}         


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannercard/bannercardview.tsx